import { render, staticRenderFns } from "./EPGProviderMappings.vue?vue&type=template&id=86b4ac24&"
import script from "./EPGProviderMappings.vue?vue&type=script&lang=js&"
export * from "./EPGProviderMappings.vue?vue&type=script&lang=js&"
import style0 from "./EPGProviderMappings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports